// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MNx5","left":"styles_left__oK552","desktopActions":"styles_desktopActions__1x-MH","title":"styles_title__2xdeE"};